import Objdict from "objdict"
import Unit from "@frog/source/models/Unit.js"
import shortid from "shortid"

export default class Delta {
    static editUnit(stage, unit, deltaunit, {isAbsolute} = {}) {
        if(isAbsolute == true) {
            if(deltaunit.health !== undefined) {
                unit.health = deltaunit.health
                unit.health = Math.max(unit.health, 0)
            }
            if(deltaunit.armor !== undefined) {
                unit.armor = deltaunit.armor
                unit.armor = Math.min(unit.armor, unit.maxarmor)
                unit.armor = Math.max(unit.armor, 0)
            }
        } else {
            if(deltaunit.health !== undefined) {
                unit.health += deltaunit.health
                unit.health = Math.max(unit.health, 0)
            }
            if(deltaunit.armor !== undefined) {
                unit.armor += deltaunit.armor
                unit.armor = Math.min(unit.armor, unit.maxhealth)
                unit.armor = Math.max(unit.armor, 0)
            }
        }
        if(deltaunit.experience != undefined) {
            unit.experience = deltaunit.experience
        }
        if(deltaunit.element != undefined) {
            unit.element = deltaunit.element
        }
        if(deltaunit.image != undefined) {
            unit.image = deltaunit.image
        }
        if(deltaunit.sprites != undefined) {
            unit.sprites = deltaunit.sprites
        }
        if(deltaunit.mode != undefined) {
            unit.mode = deltaunit.mode
        }
        if(deltaunit.maxhealth != undefined) {
            unit.maxhealth = deltaunit.maxhealth
        }
        if(deltaunit.moverange != undefined) {
            unit.moverange = deltaunit.moverange
        }
        if(deltaunit.defense != undefined) {
            unit.defense = deltaunit.defense
        }
        if(deltaunit.power != undefined) {
            unit.power = deltaunit.power
        }
        if(deltaunit.level != undefined) {
            unit.level = deltaunit.level
        }
        if(deltaunit.score != undefined) {
            unit.score = deltaunit.score
        }
        if(deltaunit.faceKey != undefined) {
            unit.faceKey = deltaunit.faceKey
        }
        if(deltaunit.bodyKey != undefined) {
            unit.bodyKey = deltaunit.bodyKey
        }
        if(deltaunit.direction != undefined) {
            unit.direction = {}
            unit.direction.x = deltaunit.direction.x ?? 0
            unit.direction.y = deltaunit.direction.y ?? 0
        }
        if(deltaunit.state != undefined) {
            unit.state = deltaunit.state
        }
        if(deltaunit.isDead != undefined) {
            unit.isDead = deltaunit.isDead
        }
        if(deltaunit.deathTimer != undefined) {
            unit.deathTimer = deltaunit.deathTimer
        }
        if(deltaunit.hasBeenRemoved !== undefined) {
            unit.hasBeenRemoved = deltaunit.hasBeenRemoved
        }
        if(deltaunit.position != undefined) {
            if(isAbsolute == true
            || deltaunit.position.mode == "absolute") {
                if(deltaunit.position.x !== undefined) {
                    unit.position.x = deltaunit.position.x
                }
                if(deltaunit.position.y !== undefined) {
                    unit.position.y = deltaunit.position.y
                }
                if(deltaunit.position.z !== undefined) {
                    unit.position.z = deltaunit.position.z
                }
            } else {
                unit.position.x += deltaunit.position.x || 0
                unit.position.y += deltaunit.position.y || 0
                unit.position.z += deltaunit.position.z || 0
            }
            // TODO: RE-CALCULATE TRAP ZONES?? OR CANCEL
            // POSITIONING-BASED EFFECTS LIKE BIND??
        }
        if(deltaunit.energy != undefined) {
            Object.keys(deltaunit.energy).forEach((key) => {
                if(deltaunit.energy[key] != undefined) {
                    unit.energy[key] = deltaunit.energy[key]
                }
            })
        }
        if(deltaunit.effects != undefined) {
            Objdict.forEach(deltaunit.effects, (deltaunit, effectKey) => {
                if(deltaunit == undefined) {
                    delete unit.effects[effectKey]
                } else if(unit.effects[effectKey] == undefined) {
                    unit.effects[effectKey] = deltaunit
                } else {
                    unit.effects[effectKey] = Objdict.merge(unit.effects[effectKey], deltaunit)
                }
            })
        }
        if(deltaunit.inventory != undefined) {
            if(deltaunit.inventory.count != undefined) {
                unit.inventory.count += deltaunit.inventory.count
            }
            if(deltaunit.inventory.items != undefined) {
                Objdict.forEach(deltaunit.inventory.items, (item, key) => {
                    if(item == undefined) {
                        delete unit.inventory.items[key]
                    } else {
                        unit.inventory.items[key] = item
                    }
                })
            }
        }
        if(deltaunit.item !== undefined) {
            if(deltaunit.item == null) {
                delete unit.item
            }
            unit.item = deltaunit.item
        }
        if(deltaunit.affiliation != undefined) {
            unit.affiliation = deltaunit.affiliation
        }
        return unit
    }
    static editStage(stage, deltastages) {
        if(deltastages instanceof Array == false) {
            deltastages = [deltastages]
        }
        deltastages.forEach((deltastage) => {
            if(deltastage == undefined) {
                return
            }

            // DELTA SCHEMA v2 - now supports just .unit to shortcut .units[unitKey]
            if(deltastage.unit != undefined) {
                deltastage.stage = {"unit": deltastage.unit} // TODO DEPRECATE THIS!!
            }
            if(deltastage.stage != undefined) {
                let deltaunits = deltastage.stage.units
                if(deltaunits == undefined
                && deltastage.stage.unit) {
                    deltaunits = [deltastage.stage.unit]
                }

                Objdict.forEach(deltaunits, (deltaunit, unitKey) => {
                    if(deltaunit == undefined) {
                        delete stage.units[unitKey]
                        return
                    }
                    if(stage.units[deltaunit.key] == undefined) {
                        deltaunit.key = deltaunit.key || shortid.generate()
                        stage.units[deltaunit.key] = Unit.instantiate({"unit": deltaunit})
                        return
                    }
                    Delta.editUnit(stage, stage.units[deltaunit.key], deltaunit, {"isAbsolute": true})
                })

                return
            }
            if(deltastage.player !== undefined) {
                if(deltastage.player.inventory !== undefined) {
                    if(deltastage.player.inventory.items != undefined) {
                        Objdict.forEach(deltastage.player.inventory.items, (item, key) => {
                            if(item == undefined) {
                                delete stage.player.inventory.items[key]
                            } else {
                                stage.player.inventory.items[key] = item
                            }
                        })
                    }
                }
                // TODO: player.party
                // TODO: player.day?
                if(deltastage.player.score !== undefined) {
                    stage.player.score = deltastage.player.score
                }
            }
            if(deltastage.dialogue !== undefined) {
                stage.dialogue = stage.dialogue || {}
                stage.dialogue.text = deltastage.dialogue.text
                stage.dialogue.index = deltastage.dialogue.index
                // stage.dialogue.speakingCharacter = deltastage.dialogue.speakingCharacter
                stage.dialogue.type = deltastage.dialogue.type
                stage.dialogue.data = deltastage.dialogue.data
                // stage.dialogue.tags = deltastage.dialogue.tags

                // stage.dialogue.characters = stage.dialogue.characters || {}
                // stage.dialogue.characters[stage.dialogue.speakingCharacter] = stage.dialogue.characters[stage.dialogue.speakingCharacter] || {}
                // stage.dialogue.characters[stage.dialogue.speakingCharacter].tags = stage.dialogue.characters[stage.dialogue.speakingCharacter].tags || {}
                // Objdict.forEach(deltastage.dialogue.tags, (value, key) => {
                //     if(key == "_") return
                //     stage.dialogue.characters[stage.dialogue.speakingCharacter].tags[key] = value
                // })
            }
            if(deltastage.dialogue === undefined) {
                delete stage.dialogue
            }
            if(deltastage.currentEncounter !== undefined) {
                stage.currentEncounter = deltastage.currentEncounter
            }

            if(deltastage.tag != undefined) {
                stage.tags[deltastage.tag.name] = deltastage.tag
                return
            }

            // DELTA SCHEMA v1 - a full stage object. only supported relative values.
            if(deltastage.actionMark != undefined) {
                stage.actionMark = deltastage.actionMark
            }
            // if(deltastage.light != undefined) {
            //     stage.light = deltastage.light
            // }
            Objdict.forEach(deltastage.units, (deltaunit, key) => {
                const unit = stage.units[key]
                if(unit == undefined) {
                    if(deltaunit.mode == "create") {
                        stage.units[key] = Unit.instantiate({"unit": deltaunit})
                    }
                    return
                }
                if(deltaunit == undefined) {
                    delete stage.units[key]
                    return
                }
                Delta.editUnit(stage, unit, deltaunit)
            })
            if(deltastage.zone != undefined) {
                stage.zone = deltastage.zone
            }
            if(deltastage.turn != undefined) {
                if(deltastage.turn.number != undefined) {
                    stage.turn.number = deltastage.turn.number
                }
                if(deltastage.turn.affiliation != undefined) {
                    stage.turn.affiliation = deltastage.turn.affiliation
                }
            }
        })
        return stage
    }
}


// // TODO: also shadow the tiles
// action.shadowtiles = clonedeep(action.shadowtiles)
// if(action.results != undefined) {
//     Object.keys(action.results).forEach((key) => {
//         const result = action.results[key]
//         if(key.substring(0, 5) === "tile:") {
//             const tile = action.shadowtiles.find((tile) => tile.key == key.substring(5))
//             if(tile != undefined) {
//                 return
//             }
//             tile.isBurning = result.isBurning
//             return
//         }
//         // else is unit!!
//     })
// }

// // USED TO BE IN THE ATTACK BEAT PERFORMANCE
// if(key.substring(0, 5) == "tile:") {
//     let position = key.substring(5)
//     let tile = model.game.chapter.stage.map.tiles[position]
//     if(tile == undefined) {
//         return
//     }
//     tile.isBurning = result.isBurning || tile.isBurning
//     return
// }
// if(result.effects) {
//     unit.applyEffects(result.effects)
// }
// if(result.hasPerformedAction != undefined) {
//     if(result.hasPerformedAction == false) {
//         unit.hasPerformedMove = false
//         unit.hasPerformedAttack = false
//         unit.hasPerformedAction = false
//     }
// }

// if(key == "performer") {
//     unit = stage.findUnitByKey(action.performer.key)
// } else if(key == "target") {
//     unit = stage.findUnitByKey(action.target.key)
// }
